import { GetAllProjectTemplatesAPI } from "../../services/api/project-template-api";
import { TemplateActionTypes } from "./template-types";

export const fetchTemplates = (searchQuery) => {
  return async (dispatch) => {
    try {
      dispatch(fetchTemplatesStart());

      const allTemplates = await GetAllProjectTemplatesAPI(searchQuery);
      if (
        allTemplates?.response?.status === 200 ||
        allTemplates?.status === 200
      ) {
        let payload = [
          allTemplates.data.dataList,
          allTemplates.data.totalCount,
        ];

        dispatch(fetchTemplatesSuccess(payload));
        dispatch(setSearchTemplatesQuery(searchQuery));

        dispatch(setTemplatesOnPage(allTemplates.data.dataList));

        return allTemplates.data.dataList;
      } else {
        throw new Error(allTemplates?.response?.data);
      }
    } catch (error) {
      dispatch(fetchTemplatesFailure());
      console.log(error);
    }
  };
};

export const fetchTemplatesStart = () => ({
  type: TemplateActionTypes.FETCH_TEMPLATES_START,
});

export const fetchTemplatesFailure = () => ({
  type: TemplateActionTypes.FETCH_TEMPLATES_FAILURE,
});

export const fetchTemplatesSuccess = (payload) => ({
  type: TemplateActionTypes.FETCH_TEMPLATES_SUCCESS,
  payload: payload,
});

export const setTemplatesOnPage = (templatesOnPage) => ({
  type: TemplateActionTypes.SET_TEMPLATES_ON_PAGE,
  payload: templatesOnPage,
});

export const setSearchTemplatesQuery = (searchQuery) => ({
  type: TemplateActionTypes.SET_SEARCH_TEMPLATES_QUERY,
  payload: searchQuery,
});

export const addSelectedTemplate = (id) => ({
  type: TemplateActionTypes.ADD_SELECTED_TEMPLATE,
  payload: id,
});

export const deleteSelectedTemplate = (id) => ({
  type: TemplateActionTypes.DELETE_SELECTED_TEMPLATE,
  payload: id,
});

export const setSelectedTemplate = (idList) => ({
  type: TemplateActionTypes.SET_SELECTED_TEMPLATE,
  payload: idList,
});
